import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enAuth from "./locales/en/auth.json";

import hiCommon from "./locales/hi/common.json";
import hiHome from "./locales/hi/home.json";
import hiAuth from "./locales/hi/auth.json";

import arCommon from "./locales/ar/common.json";
import arHome from "./locales/ar/home.json";
import arAuth from "./locales/ar/auth.json";

import zhCommon from "./locales/zh/common.json";
import zhHome from "./locales/zh/home.json";
import zhAuth from "./locales/zh/auth.json";

import bnCommon from "./locales/bn/common.json";
import bnHome from "./locales/bn/home.json";
import bnAuth from "./locales/bn/auth.json";

import esCommon from "./locales/es/common.json";
import esHome from "./locales/es/home.json";
import esAuth from "./locales/es/auth.json";



i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                common: enCommon,
                home: enHome,
                auth: enAuth
            },
            hi: {
                common: hiCommon,
                home: hiHome,
                auth: hiAuth
            },
            ar: {
                common: arCommon,
                home: arHome,
                auth: arAuth
            },
            zh: {
                common: zhCommon,
                home: zhHome,
                auth: zhAuth
            },
            bn: {
                common: bnCommon,
                home: bnHome,
                auth: bnAuth
            },
            es: {
                common: esCommon,
                home: esHome,
                auth: esAuth
            }
        },

        fallbackLng: "en",

        ns: ["common", "home", "auth"],
        defaultNS: "common",

        interpolation: {
            escapeValue: false
        },

        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"]
        },

        react: {
            useSuspense: false
        }
    });

export default i18n;